import type { FC } from "react";
import type { PostDto } from "shared";
import "./ListEvents.css";
import { getPostDate } from "../calendar/calendar.utils";
import { TimeFormatter, useTime } from "../common/time/useTime";
import { SocialMediaPost } from "../social-media/SocialMediaPost";

type Props = {
	posts: Array<PostDto>;
};

export const ListEvents: FC<Readonly<Props>> = ({ posts }) => {
	const { format } = useTime();
	return (
		<div className="list-events">
			{posts.map((post) => (
				<div className="event" key={post.id}>
					<span>{format(TimeFormatter.Date, getPostDate(post))}</span>
					<span>{format(TimeFormatter.Time, getPostDate(post))}</span>
					<SocialMediaPost className="post" post={post} />
				</div>
			))}
		</div>
	);
};
